import { removeHiddenClassBody } from "../utils/remove-hidden-class-body";
import { setHiddenClassBody } from "../utils/set-hidden-class-body";
import AbstractComponent from "./abstract-component";

const getPropertiesMarkup = (properties) => {

  return Object.values(properties)
    .map((property) => {
      return (
        `<tr>
          <td>
            ${property.title}
            ${property.note
          ? `<div class="tooltip">
              <button class="tooltip__showButton" type="button">
                <svg class="tooltip__icon" height="20px" viewBox="0 -960 960 960" width="20px">
                  <path d="M478-240q21 0 35.5-14.5T528-290q0-21-14.5-35.5T478-340q-21 0-35.5 14.5T428-290q0 21 14.5 35.5T478-240Zm-36-154h74q0-33 7.5-52t42.5-52q26-26 41-49.5t15-56.5q0-56-41-86t-97-30q-57 0-92.5 30T342-618l66 26q5-18 22.5-39t53.5-21q32 0 48 17.5t16 38.5q0 20-12 37.5T506-526q-44 39-54 59t-10 73Zm38 314q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/>
                </svg>
              </button>
              <div class="tooltip__textWrap">
                <button class="tooltip__closeButton" type="button" title="Закрыть">
                  <svg aria-hidden="true" width="16" height="16">
                    <use class="" href="sienge/img/sprite.svg#icon-close"></use>
                  </svg>
                </button>
                <p class="tooltip__text" role="tooltip">${property.note}</p>
              </div>
              <div class="tooltip__overlay"></div>
            </div>`
          : ``}
          </td>
          <td>${property.value}</td>
        </tr>`
      );
    }).join(`\n`);
};


const createTemplate = (className, properties) => {
  return (
    `<table ${className ? `class="${className}"` : ``}>
      ${getPropertiesMarkup(properties)}
    </table>`
  );
};


export default class PropertyProductTableComponent extends AbstractComponent {
  constructor({className = ``, properties = {}}) {
    super();

    this._className = className;
    this._properties = properties;

    this._setButtonClickHandler();
    this._setOverlayClickHandler();
    this._setCloseButtonClickHandler();
  }

  getTemplate() {
    return createTemplate(this._className, this._properties);
  }

  _setButtonClickHandler() {
    if (document.documentElement.clientWidth > 1000) {
      return;
    }

    const buttons = this.getElement().querySelectorAll(`.tooltip__showButton`);
    Array.from(buttons).forEach((button) => {
      button.addEventListener(`click`, () => {
        const parent = button.parentElement;
        parent.dataset.show = `true`;
        setHiddenClassBody();
      });
    });
  }

  _setOverlayClickHandler() {
    if (document.documentElement.clientWidth > 1000) {
      return;
    }

    const overlays = this.getElement().querySelectorAll(`.tooltip__overlay`);
    Array.from(overlays).forEach((overlay) => {
      overlay.addEventListener(`click`, () => {
        const parent = overlay.parentElement;
        parent.dataset.show = `false`;
        removeHiddenClassBody();
      });
    });
  }

  _setCloseButtonClickHandler() {
    if (document.documentElement.clientWidth > 1000) {
      return;
    }

    const overlays = this.getElement().querySelectorAll(`.tooltip__closeButton`);
    Array.from(overlays).forEach((overlay) => {
      overlay.addEventListener(`click`, () => {
        const parent = overlay.parentElement.parentElement;
        parent.dataset.show = `false`;
        removeHiddenClassBody();
      });
    });
  }
}

// кнопка закрытия
// кнопка esc
